/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
var getters = {
  nickName: function nickName(state) {
    return state.user.loginResult.userName;
  }
};
export default getters;